import { render, staticRenderFns } from "./DiagnosticImageAdd.vue?vue&type=template&id=547e3424"
import script from "./DiagnosticImageAdd.vue?vue&type=script&lang=js"
export * from "./DiagnosticImageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports